import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close }) {
  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>
      <div style={{ padding: '10px 0px' }}>
        <h4>Histórico de Aferição do Veículo</h4>
      </div>
      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data}>
          <SimpleTable
            style={{ width: '100px' }}
            url="afericaoveiculo/historico"
            cells={[
              {
                id: 'hvma_data_str',
                label: 'Data',
              },
              {
                id: 'usua_login',
                label: 'Login',
              },
              {
                id: 'desc_hvma_tipo',
                label: 'Tipo',
              },
              {
                id: 'desc_hvma_modo',
                label: 'Modo',
              },
              {
                id: 'desc_hvma_operacao',
                label: 'Status',
              },
            ]}
            unique={['hvma_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Histórico de Aferição do Veículo'}
            restProps={''}
            query={{
              wherefield: ['veic_placa_apresentacao'],
              valuewherefield: [data.veic_placa],
              typewherefield: ['EQUALS'],
            }}
          />
        </FormWrapper>
      </S.Wrapper>
      <div style={{ padding: '30px 0px 0px 0px' }}>
        <h4>Produtos</h4>
      </div>
      <S.Wrapper>
        <FormWrapper ref={reference} initialData={data}>
          <SimpleTable
            style={{ width: '100px' }}
            url="veiculo/produto"
            cells={[
              {
                id: 'prde_codigo',
                label: 'Código',
              },
              {
                id: 'prde_nome',
                label: 'Nome',
              },
              {
                id: 'prod_status',
                label: 'Status',
              },
            ]}
            unique={['prde_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Produtos do Veículo'}
            restProps={''}
            query={{
              wherefield: ['veic_placa'],
              valuewherefield: [data.veic_placa],
              typewherefield: ['EQUALS'],
            }}
          />
        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
